export default "__VITE_ASSET__CE6i9k4g__"